export default {
  main: {
    site_id: 18759645,
    title: "Bet Platinum",
    enableWorldCup: true,
    enableWebCashier: true,
    hotjarId: 4937892,
    needAdminForResetPin: true,
    alwaysShowCheckTicket: true,
    ticketAvailableViewMode: ["card"],
    homeMediaSlides: [
      {
        type: "sport",
        path: "betting/prematch",
      },
    ],
    showBetBuilderSection: true,
    logoSize: "extra-huge",
    staffPassword: "0",
    useCurrencySymbol: false,
    rfidPinCode: true,
    websitePasswordHash: "a75353bf1273f307a92b5fb7f929ad0b9e7fbca30627ffbc4399378322817d47",
    enableTicketPopupFlow: true,
    enabel18PlusIcon: true,
    enableHeaderAdminSection: true,
    termsAndConditions: false,
    availableLanguages: {
      "@replace": true,
      eng: {
        short: "EN",
        name: "Eng",
        order: 1,
      },
      "pt-br": {
        short: "PT-BR",
        name: "PT-BR",
        order: 2,
      },
      spa: {
        short: "ES",
        name: "Esp",
        order: 3,
      },
    },
  },
  tickets: {
    enableWinIdentification: true,
  },
  betBuilder: {
    brandName: "betone",
  },
  odd: {
    roundDecimalCoefficients: 3, // rounding of coefficients, number of significant digits
  },
  betslip: {
    betDetailsOrder: [
      "total_odd",
      "tax_on_stake",
      "total_stake",
      "possible_win",
      "bonus",
      "min_possible_win",
      "estimated_return",
      "tax_on_return_or_profit",
      "total_win",
    ],
  },
  adminPageButtons: [
    {
      name: "Admin User",
      type: "adminUserSections",
      hideOnRestrictMode: false,
      enabled: true,
    },
    {
      name: "Application and terminal management",
      type: "applicationAndTerminal",
      enabled: true,
    },
    {
      name: "Tickets",
      type: "lastTicket",
      enabled: true,
    },
    {
      name: "Financial tracking",
      type: "financialTracking",
      enabled: true,
      hideOnRestrictMode: false,
    },
    {
      name: "Open last log file",
      type: "openLastLogFile",
      enabled: true,
      hideOnRestrictMode: true,
    },
    {
      name: "Lock",
      type: "lockAndUnlock",
      param: { type: "lock" },
      enabled: true,
    },
    {
      name: "Unlock",
      type: "lockAndUnlock",
      param: { type: "unlock" },
      enabled: true,
    },
    {
      name: "Devices",
      type: "devices",
      enabled: true,
      hideOnRestrictMode: true,
    },
  ],
  lastTicketButtons: [
    {
      name: "Search and print Lottery tickets",
      type: "printLastTicketCasino",
    },
    {
      name: "Show last tickets",
      type: "printLastTicket",
    },
    {
      name: "Print Last Cash out ticket",
      type: "printLastCashoutTicket",
    },
    {
      name: "Print last bet ticket",
      type: "printLastBetTicket",
    },
  ],
  env: {
    lang: "spa",
  },
  routes: [
    {
      url: 'worldcup',
      name: 'FIFA World Cup',
      enabled: true,
      disableInHeader: true,
    },
    {
      name: 'Betting',
      url: 'betting/prematch/all',
      type: 'sportsBook',
      enabled: true,
      nestedItems: [
        {
          url: 'betting/live/all',
          type: 'live',
          name: 'Live',
          enabled: true,
          icon: 'circle',
        },
        {
          url: 'betting/prematch/all',
          type: 'prematch',
          name: 'Sports',
          enabled: true,
          icon: 'casino-categories-Sportsbook',
        },
        {
          url: 'betting/prematch/popular',
          type: 'popular',
          name: 'Popular',
          enabled: true,
          icon: 'casino-categories-PopularGames',
        },
        {
          url: 'betting/prematch/betBuilder',
          type: 'betBuilder',
          name: 'Bet Builder',
          enabled: true,
          icon: 'bet-builder',
        },
        {
          url: 'betting/prematch/outrights',
          name: 'Outrights',
          type: 'outrights',
          enabled: true,
          icon: '',
        },
        {
          url: 'betting/results',
          name: 'Results',
          type: 'results',
          enabled: true,
          icon: '',
        },
      ],
    },
    {
      url: 'betting/prematch/virtuals',
      type: 'virtuals',
      name: 'Virtuals',
      enabled: true,
      icon: 'casino-categories-VirtualBetting',
      nestedItems: [
        {
          name: 'Games',
          url: 'betting/prematch/virtuals',
          enabled: true,
          type: 'virtuals',
          icon: '',
        },
        {
          name: 'Results',
          type: 'virtual-results',
          url: 'betting/virtual-results',
          enabled: true,
          icon: '',
        },
      ],
    },
    {
      name: 'Casino',
      url: 'casino',
      type: 'casino',
      enabled: true,
      icon: 'casino-7',
    },
  ],
  terminal: {
    disableTicket: false,
  },
  defaultTerminalParams: { pid: 18759645, tid: 34343, token: "jr7dHA==", currency: "USD" },
};
